<template>
  <div class="two_msg_box">
    <div class="content">
      {{content}}
    </div>
    <div class="btn_box">
      <div @click="close">{{$t('取消')}}</div>
      <div class="ok" @click="ok">{{$t('确认')}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EvaluateAlert',
  props: {
    content: {
      type: String,
      default: '',
    },
  },
  methods: {
    close() {
      this.$emit('close')
    },
    ok() {
      this.$emit('ok')
    }
  }
}
</script>

<style lang="scss" scoped>
.two_msg_box {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3000;
  transform: translate3d(-50%, -50%, 0);
  background-color: #fff;
  width: 300px;
  border-radius: 8px;
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.2);
  font-size: 16px;
  .content {
    padding: 24px 30px;
    text-align: center;
    font-size: 16px;
    line-height: 20px;
    color: #000;
    font-family: 'Aspira Light';
    font-weight: 200;
  }
  .btn_box {
    height: 53px;
    border-top: 1px solid #e5e5e5;
    display: flex;
    font-family: 'Aspira Medium';
    font-weight: 500;
    color: #666;
    div {
      display: flex;
      height: 53px;
      justify-content: center;
      align-items: center;
      flex: 1;
      cursor: pointer;
      &.ok {
        border-left: 1px solid #e5e5e5;
        @include font-color();
      }
    }
  }
}
</style>